import './cover-image.scss';

export default function coverImageDirective() {
  return {
    restrict: 'A',
    link($scope, $elem, $attr) {
      $attr.$observe('coverImage', (newUrl) => {
        if (!newUrl) {
          return;
        }
        $elem[0].style.backgroundImage = `url('${newUrl}?output-format=jpeg&output-quality=80&background-color=FFFFFF&downsize=*:${$elem[0].hasAttribute('cover-image-large') ? 700 : 400}px')`;
      });
    },
  };
}



// WEBPACK FOOTER //
// ./src/app/shared/cover-image/cover-image.directive.js